module.exports = __webpack_public_path__ + "img/img16.28e780a8.svg";